// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"search_loadingContainer__2rSbA","clearText":"search_clearText__1ztEE"};